import React from 'react';

import styled from 'styled-components';

import { INutritionInfo } from '@rbi-ctg/menu';

import { NutritionItem } from './nutrition-item';
import { SanityNutritionItemGroup } from './types';

const LineItems = styled(NutritionItem)`
  text-indent: 1rem;
`;

type NutritionItemGroupProps = {
  nutritionItemGroup: SanityNutritionItemGroup;
  nutritionInfo: INutritionInfo;
  roundNutritionValue: (val: number) => number;
};

export const NutritionItemGroup: React.FC<NutritionItemGroupProps> = ({
  nutritionInfo,
  nutritionItemGroup,
  roundNutritionValue,
}) => {
  if (!nutritionItemGroup.mainItem) {
    return null;
  }

  return (
    <div data-testid="nutrition-item-group">
      <NutritionItem
        data-testid="nutrition-item-group-main-item"
        nutritionInfo={nutritionInfo}
        nutritionItem={nutritionItemGroup.mainItem}
        roundNutritionValue={roundNutritionValue}
      />
      {nutritionItemGroup.lineItems?.map(
        (item, index) =>
          item && (
            <LineItems
              data-testid="nutrition-item-group-line-item"
              key={item?.nutritionKey || index}
              nutritionInfo={nutritionInfo}
              nutritionItem={item}
              roundNutritionValue={roundNutritionValue}
            />
          )
      )}
    </div>
  );
};
